/* import {  } from '@/scripts/constants/test'; */

const isFunction = f => f && {}.toString.call(f) === '[object Function]';
const wrapWithUrl = s => `url(${s})`;
const wrapWithStyle = s => ({ 'background-image': wrapWithUrl(s) });
const getAsset = (name = '', params = {}) => {
  const {
    path = '',
    type = 'svg',
    url = false,
    style = false,
    strict = false,
    fallback = 'png/wifi-off.png',
    modifier = '',
  } = params;

  const getResult = s => (style ? wrapWithStyle(s) : url ? wrapWithUrl(s) : s);

  /* init (fallback) */
  let fallbackFilePath = null;
  let result = getResult(null);

  try {
    const filePath = require(`@/assets/${type}${
      path ? `/${path}` : ''
    }/${name}${modifier ? `-${modifier}` : ''}.${type}`);

    /* rewrite */
    return getResult(filePath);
  } catch (error) {
    // const customError = `no ${name} asset`;

    /* TODO: turn on */
    if (name) {
      // console.warn(customError);
      // console.log('params', params);
    }
  }

  try {
    if (!strict) fallbackFilePath = require(`@/assets/${fallback}`);
    result = getResult(fallbackFilePath);
  } catch (error) {
    // console.log('', );
  }

  return result;
};

async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (e) {
    console.warn(e);
  }
}

const getRandomInt = (maximum = 1, minimum = 0) => {
  /* min inclusive
  max inclusive */
  const min = Math.ceil(minimum);
  const max = Math.floor(maximum);
  const result = Math.floor(Math.random() * (max - min + 1)) + min;

  return result;
};

const flagNameFromCountry = spaced => {
  if (!spaced || !spaced.toLowerCase) return;

  const kebab = spaced
    .toLowerCase()
    .split(' ')
    .join('-');

  const result = `flag-${kebab}`;

  return result;
};

const truncate = (str, maxLength) => {
  return str.length > maxLength ? str.slice(0, maxLength - 1) + '...' : str;
};

/* >user data */
const getAvatar = (avatar, params = {}) => {
  if (!avatar) return null;

  const { resolution = '360x360' } = params;
  const { thumbnails } = avatar;

  if (!thumbnails) return null;

  const result = thumbnails[resolution].url;

  return result;
};
/* <user data */

/*  */
const errorReducer = (prev, curr = {}) => {
  const { message, details = [] } = curr;

  if (details.length) {
    const result = details.map(({ messages }) => {
      const all = messages.map(message => `${message} `);

      return all;
    });

    return `${prev ? `${prev}, ` : ''} ${result}`;
  } else if (message) {
    return `${prev ? `${prev}, ` : ''} ${curr.message}`;
  }
};

const readError = (e = {}) => {
  let result = 'Error';

  const defaultMessage = e.toString ? e.toString() : null;

  if (defaultMessage) result = defaultMessage;

  const { response = {} } = e;
  const { data = {} } = response;
  const { errors = [] } = data;

  if (errors.length) {
    result = errors.reduce(errorReducer, '');
  }

  return result;
};

const getGameImage = (game = {}, params = {}) => {
  const { images, id } = game;
  const fieldTranslator = {
    logo: 'game_connection_icon',
    bg: 'game_connection_background',
  };
  const { style = false, field = 'logo' } = params;

  const storage = images[fieldTranslator[field]];
  const cmsResult = storage
    ? style
      ? wrapWithStyle(storage.url)
      : storage.url
    : null;
  const localResult = getAsset(`${id}`, {
    /* path: 'games/logo', */
    type: 'png',
    style,
  });
  const result = cmsResult || localResult;

  return result;
};

/*  */
export {
  isFunction,
  getAsset,
  copyToClipboard,
  getRandomInt,
  flagNameFromCountry,
  truncate,
  getAvatar,
  readError,
  wrapWithUrl,
  wrapWithStyle,
  getGameImage,
};
